import { render, staticRenderFns } from "./NeuanmeldungenBenutzerCard.vue?vue&type=template&id=3d8de21e&scoped=true"
import script from "./NeuanmeldungenBenutzerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NeuanmeldungenBenutzerCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NeuanmeldungenBenutzerCard.vue?vue&type=style&index=0&id=3d8de21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8de21e",
  null
  
)

export default component.exports